import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { useAuth } from '../../contexts/auth';
import Head from '../../components/Head';
import { PepsicoLogoBlue } from '../../assets/images';
import Card from '../../components/Auth/Card';
import { makeStyles } from '@material-ui/core/styles';

const Error404 = () => {
  const classes = useStyles();
  const { isGPID } = useAuth();

  return (
    <div className={classes.container}>
      <Head>Página não encontrada</Head>
      <Card className={classes.card}>
        <Grid item>
          <Box padding={4}>
            <img src={PepsicoLogoBlue} width="168" alt="Logo" />
          </Box>
        </Grid>

        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>Página não encontrada</Typography>
            </Grid>
            <Grid item xs={12} className={classes.link}>
              <Link to={!isGPID ? '/' : '/minha-saude/vacina'}>
                <Typography>
                  {!isGPID ? 'Voltar para Login' : 'Voltar'}
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default Error404;

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 'auto',
    textAlign: 'center',
    paddingTop: theme.spacing(20),
  },
  card: {
    margin: 'auto',
  },
  media: {
    padding: '10px',
  },
  link: {
    textAlign: 'right',
  },
}));
